/**
 * Logic for a Sticky Bottom Element
 * (may require some initial css, this is only for toggling a class)
 * Author: Imarc 2019
 */

module.exports = function stickyConstructor(passedConfig) {
    const config = {
        stickySelector: passedConfig.stickySelector || '.js-stickyBottom',
        nextReferenceSelector: passedConfig.nextReferenceSelector || '.site-footer',
    };

    const stickyNode = document.querySelector(config.stickySelector);
    const referenceNode = document.querySelector(config.nextReferenceSelector);

    let destickPoint = referenceNode.offsetTop;
    let spaceReplace = `${stickyNode.offsetHeight}px`;

    const setValues = () => {
        destickPoint = referenceNode.offsetTop;
        spaceReplace = `${stickyNode.offsetHeight}px`;
    };

    const initSticky = () => {
        setValues();

        const windowScrollPoint = window.pageYOffset;
        const keyScrollPoint = windowScrollPoint + window.innerHeight;

        let ticking = false;

        if (!ticking) {
            window.requestAnimationFrame(() => {
                if (keyScrollPoint >= destickPoint) {
                    stickyNode.classList.add('-relative');
                    referenceNode.style.marginTop = '0px';
                } else {
                    stickyNode.classList.remove('-relative');
                    referenceNode.style.marginTop = spaceReplace;
                }
            });

            ticking = true;
        }
    };

    window.addEventListener('scroll', initSticky);
    initSticky();
};
